import {
  Button,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form4797 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Form 4797: Sale of Business Property | TaxZerone"
          description="Learn how to file IRS Form 4797 to report sales or exchanges of business property. Understand gain or loss rules and IRS reporting with TaxZerone"
          keywords=""
          canonical="resources/business-tax/form-4797/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Form 4797</span>
          </span>{' '}
          Sales of Business Property
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',

                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '200px',
                      height: '130px',
                      borderTop: '2px solid #01456c',
                      borderLeft: '2px solid #01456c',
                      borderTopLeftRadius: '12px',
                    },

                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      width: '200px',
                      height: '130px',
                      borderBottom: '2px solid #01456c',
                      borderRight: '2px solid #01456c',
                      borderBottomRightRadius: '12px',
                    },
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-4797/"
                  />

                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    itemProp="headline"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Form 4797 at a Glance
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    It is used to report the{' '}
                    <span style={{ fontWeight: 600 }}>
                      sale, exchange, or disposition of business property
                    </span>
                    , including real estate, equipment, vehicles, and other
                    depreciable assets. It helps determine{' '}
                    <span style={{ fontWeight: 600 }}>
                      gains, losses, and depreciation recapture
                    </span>
                    .
                  </Typography>

                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span style={{ fontWeight: 600 }}>Who Files:</span>{' '}
                      Businesses that sell or exchange business property,
                      dispose of depreciable assets, report{' '}
                      <span style={{ fontWeight: 600 }}>
                        Section 1231 gains or losses
                      </span>
                      , or have certain involuntary conversions.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>Filing:</span> File Form
                      4797 with your{' '}
                      <span style={{ fontWeight: 600 }}>main tax return</span>,
                      such as Form 1120-S, Form 1065, Form 1120, or Schedule C.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>Key Rules:</span> Report{' '}
                      <span style={{ fontWeight: 600 }}>
                        Section 1231 gains/losses
                      </span>{' '}
                      and calculate{' '}
                      <span style={{ fontWeight: 600 }}>
                        depreciation recapture under Sections 1245 and 1250
                      </span>
                      .
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        Special Situations:
                      </span>{' '}
                      Involuntary conversions, installment sales, and like-kind
                      exchanges may require additional forms such as{' '}
                      <span style={{ fontWeight: 600 }}>
                        Forms 6252 or 8824
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      When a business sells, exchanges, or disposes of property
                      used for trade or investment, the IRS requires the
                      transaction to be reported on{' '}
                      <Link
                        href="https://www.irs.gov/pub/irs-pdf/f4797.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 4797
                      </Link>
                      ,{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Sales of Business Property.
                      </span>{' '}
                      This includes gains and losses from the sale of real
                      estate, equipment, or other depreciable assets, and even
                      involuntary conversions due to theft or casualty.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      <Link
                        href="https://www.irs.gov/forms-pubs/about-form-4797"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 4797
                      </Link>{' '}
                      helps you determine whether the resulting gain or loss is
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        ordinary or capital
                      </span>
                      , how depreciation recapture applies, and how to correctly
                      report it with your main business tax return.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Using <span style={{ fontWeight: 600 }}>Form 4797</span>,
                      businesses can:{' '}
                    </Typography>
                    <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                      <li>Report sales or exchanges of business-use assets</li>
                      <li>
                        Recognize gains from depreciable property under Section
                        1245 or 1250{' '}
                      </li>
                      <li>
                        Record involuntary conversions (e.g., fire, theft,
                        condemnation)
                      </li>
                      <li>
                        Transfer results to{' '}
                        <Link
                          href="/business-tax/efile-irs-form-1120-s/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1120-S
                        </Link>
                        ,{' '}
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/f1065.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1065
                        </Link>
                        , or{' '}
                        <span style={{ fontWeight: 600 }}> Schedule D</span> (
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/f1040sd.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1040
                        </Link>
                        )
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Proper completion ensures your business accurately reports
                      taxable events and stays compliant with IRS rules.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                  }}
                >
                  What Is IRS Form 4797?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>IRS Form 4797</span> is used
                  to report the sale or disposition of business property,
                  including real estate and depreciable assets. It helps the IRS
                  identify taxable gains, allowable losses, and depreciation
                  recapture amounts when business property changes hands.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Common Transactions Reported on Form 4797
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Sale of machinery, buildings, or vehicles used for
                    business{' '}
                  </li>
                  <li>
                    Exchanges under{' '}
                    <span style={{ fontWeight: 600 }}>
                      Section 1031 (like-kind exchanges)
                    </span>
                  </li>
                  <li>
                    Involuntary conversions (fire, theft, natural disaster)
                  </li>
                  <li>Gain from the sale of rental or investment property</li>
                  <li>
                    Depreciation recapture for assets reported on{' '}
                    <span style={{ fontWeight: 600 }}> Form 4562</span>{' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Why Form 4797 Matters
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  1. Accurate Gain/Loss Reporting
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It ensures that your business correctly distinguishes{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    ordinary income, capital gain
                  </span>
                  , or{' '}
                  <span style={{ fontWeight: 600 }}>
                    recaptured depreciation
                  </span>
                  , preventing IRS mismatches.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  2. IRS Compliance
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Improperly reporting asset sales or ignoring depreciation
                  recapture can trigger audits or result in penalties.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  3. Tax Optimization
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Knowing how to classify gains (ordinary vs. capital) can
                  influence your tax liability and future deductions.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Who Must File Form 4797?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  You must file{' '}
                  <span style={{ fontWeight: 600 }}>Form 4797</span> if, during
                  the tax year, your business:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>Sold or exchanged property used for business purposes</li>
                  <li>Claimed depreciation on assets now sold or disposed</li>
                  <li>Reported Section 1231 gains or losses</li>
                  <li>
                    Experienced involuntary conversion (e.g., theft,
                    condemnation)
                  </li>
                  <li>Transferred depreciable property to another entity </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Entities Required to File
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Return Form
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            4797 Attachment Required
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            S Corporation{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="/business-tax/efile-irs-form-1120-s/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1120-S
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Yes, if property was sold or exchanged{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            C Corporation{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-1120"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1120
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Yes, if reporting gains or losses on business
                            property
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Partnership{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-1065"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1065
                            </Link>{' '}
                          </TableCell>
                          <TableCell>Yes, for asset dispositions </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Sole Proprietor{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-schedule-c-form-1040"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Schedule C (Form 1040)
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Yes, if selling business-use assets
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Rental Real Estate Entity{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="/resources/business-tax/form-8825/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 8825
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Yes, for sale of rental buildings or land{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 4 }}>
                  Learn how to report rental income and property sales using
                  Form 8825
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Form 4797 Filing Deadlines
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Form 4797 must be filed{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    along with your main tax return:
                  </span>
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 350, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporation </TableCell>
                          <TableCell>Form 1120-S</TableCell>
                          <TableCell>March 16, 2026</TableCell>
                          <TableCell>
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Partnership </TableCell>
                          <TableCell>Form 1065</TableCell>
                          <TableCell>March 16, 2026</TableCell>
                          <TableCell>Form 7004 </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>C Corporation </TableCell>
                          <TableCell>Form 1120 </TableCell>
                          <TableCell>April 15, 2026 </TableCell>
                          <TableCell>Form 7004</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Sole Proprietorship </TableCell>
                          <TableCell>Form 1040 (Schedule C) </TableCell>
                          <TableCell>April 15, 2026 </TableCell>
                          <TableCell>
                            {' '}
                            <Link
                              href="/tax-extension/efile-irs-form-4868-personal-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 4868
                            </Link>{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Learn how to extend your business tax filing using Form 7004
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Step-by-Step Breakdown of IRS Form 4797
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Form 4797 is divided into{' '}
                  <span style={{ fontWeight: 600 }}>four parts</span>, each
                  focusing on a different type of property transaction.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part I: Sales or Exchanges of Property Used in a Trade or
                  Business (Section 1231)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Purpose:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  To report gains or losses on property used in your business
                  held longer than one year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  If you sell an office building used for business for $500,000
                  with an adjusted basis of $350,000, the $150,000 gain is
                  reported in <span style={{ fontWeight: 600 }}> Part I</span>{' '}
                  as a{' '}
                  <span style={{ fontWeight: 600 }}>Section 1231 gain.</span>
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Gains may qualify for{' '}
                    <span style={{ fontWeight: 600 }}>
                      favorable capital gain treatment.{' '}
                    </span>{' '}
                    Enter the
                  </li>
                  <li>
                    Losses are treated as{' '}
                    <span style={{ fontWeight: 600 }}>ordinary losses</span>,
                    reducing taxable income.
                  </li>
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part II: Ordinary Gains and Losses (Section 1245 and 1250
                  Property)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Purpose:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  To calculate{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    depreciation recapture
                  </span>{' '}
                  on property where depreciation or amortization was previously
                  claimed.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Key Sections:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Section 1245 Property:{' '}
                    </span>{' '}
                    Tangible personal property like machinery, equipment, or
                    vehicles.{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Section 1250 Property:{' '}
                    </span>{' '}
                    Real property (buildings) that has been depreciated.{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  If a machine cost $50,000, with $30,000 depreciation claimed,
                  and it’s sold for $40,000 —
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  $20,000 of gain is{' '}
                  <span style={{ fontWeight: 600 }}>
                    ordinary income (recaptured depreciation)
                  </span>
                  ,
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The remaining $10,000 is a{' '}
                  <span style={{ fontWeight: 600 }}> Section 1231 gain.</span>
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Depreciation details are reported on{' '}
                  <Link
                    href="/resources/business-tax/form-4562/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 4562
                  </Link>
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part III: Gain from Disposition of Property Under Sections 179
                  or 280F(b)(2)
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Purpose:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  To recapture{' '}
                  <span style={{ fontWeight: 600 }}>
                    Section 179 deductions
                  </span>{' '}
                  previously claimed if the asset’s business use drops below 50%
                  or it’s sold early.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  {' '}
                  If you deducted a $10,000 asset under Section 179 and later
                  converted it for personal use, part of that deduction may need
                  to be recaptured and reported here.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Learn more about Section 179 deduction on{' '}
                  <Link
                    href="/resources/business-tax/form-4562/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 4562
                  </Link>
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part IV: Recapture Amounts Under Sections 179 and 280F(b)(2)
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports additional{' '}
                  <span style={{ fontWeight: 600 }}> recapture income</span> for
                  business property converted to non-business use, such as
                  vehicles or computers.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Ensure business-use percentages are correctly documented to
                  avoid underreporting.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Special Situations
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  1. Involuntary Conversions (Fire, Theft, Condemnation)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Report gains or losses when business property is destroyed or
                  seized. In some cases, gains may be deferred if you reinvest
                  in similar property under{' '}
                  <span style={{ fontWeight: 600 }}> Section 1033</span>.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  2. Installment Sales
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  If payment for sold property is received over multiple years,
                  use{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f6252.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 6252
                  </Link>{' '}
                  to report the installment method.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, fontStyle: 'italic' }}>
                  Learn about installment sale reporting using Form 6252
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  3. Like-Kind Exchanges (Section 1031)
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  If you exchanged business property for similar property,
                  report the transaction using{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f8824.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 8824
                  </Link>
                  , not 4797.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, fontStyle: 'italic' }}>
                  Understand how to report like-kind exchanges on Form 8824
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Common Mistakes to Avoid
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Error
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 100, fontWeight: 600 }}
                          >
                            Impact
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Failing to recapture depreciation correctly
                          </TableCell>
                          <TableCell>
                            Underreported income and IRS penalties{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Reporting business-use property as capital asset
                          </TableCell>
                          <TableCell>
                            Incorrect gain/loss classification{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Omitting prior-year depreciation on sold property
                          </TableCell>
                          <TableCell>Overstated gain </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Ignoring Section 1231/1245 rules
                          </TableCell>
                          <TableCell>Misclassified income </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Forgetting to include Form 4797 attachment
                          </TableCell>
                          <TableCell>Rejected or delayed tax filing </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Best Practices for Compliance
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Keep asset purchase, sale, and depreciation records for at
                    least <span style={{ fontWeight: 600 }}> 7 years.</span>
                  </li>
                  <li>
                    Verify property’s{' '}
                    <span style={{ fontWeight: 600 }}>adjusted basis</span>{' '}
                    before calculating gain/loss.
                  </li>
                  <li>
                    Reconcile totals with your main return (Form 1120-S, 1065,
                    or Schedule C).
                  </li>

                  <li>
                    Use{' '}
                    <span style={{ fontWeight: 600 }}>
                      TaxZerone’s guided e-filing
                    </span>{' '}
                    to auto-attach Form 4797 when business property is sold or
                    exchanged.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What transactions are reported on Form 4797?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Sales, exchanges, or involuntary conversions of business-use
                  property, including buildings, vehicles, and machinery.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Is Form 4797 used for personal property sales?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Only property used in trade, business, or investment
                  activities is reported here.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. What’s the difference between Section 1231, 1245, and 1250
                  property?
                </Typography>
                <Typography
                  component="ul"
                  variant="body1"
                  sx={{ mb: 2, '& li': { mb: 1.2 } }}
                >
                  <li>
                    <span style={{ fontWeight: 600 }}>Section 1231:</span>{' '}
                    Business property held &gt; 1 year.{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Section 1245:</span>{' '}
                    Depreciable personal property (equipment, vehicles).{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Section 1250:</span>{' '}
                    Depreciable real property (buildings).{' '}
                  </li>
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. How does depreciation recapture work?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  You must report part of the gain from selling a depreciated
                  asset as{' '}
                  <span style={{ fontWeight: 600 }}>ordinary income</span>, not
                  capital gain.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. Can Form 4797 be e-filed?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, but it must be submitted as an{' '}
                  <span style={{ fontWeight: 600 }}>
                    attachment to your main tax return
                  </span>{' '}
                  (e.g., Form 1120-S or 1065).
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 2,
              }}
            >
              Simplify your corporate filing with TaxZerone.
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Automatically include{' '}
              <span style={{ fontWeight: 600 }}> Form 4797</span> when selling
              or disposing of
              <br />
              business property — ensuring IRS accuracy and compliance.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=4797`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form4797;
